import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { FILES_URL, APP_API_KEY } from '../Common/constant';
import noimg from '../../assets/img/placeholders/NoImg.svg';
import {
  applyCoupon,
  makeStripePayment,
  freeProductAccess
} from '../course-overview/actions';
import Stripe from './stripe';
import { showSuccess, showError, showWarning } from '../Common/alertmessage';
import LocalStrings from '../../languages';
import { makeEmpty_Chapters, makeEmpty_Lessions } from '../mycourses/actions';

const CourseCheckout = props => {
  var { session, eventDetails, printList } = props;
  var coursepricingtype = printList.pricingtype;
  var currency = printList.tickets_by_ticketid.currency;
  var coverimage = noimg;
  var courseAmount = printList.tickets_by_ticketid.price;
  var taxName = eventDetails.resource.eventsettings_by_eventid[0].taxname;
  var taxRate = eventDetails.resource.eventsettings_by_eventid[0].tax;

  var [taxAmount, setTaxAmount] = useState(0);
  var [totalAmount, setTotalAmount] = useState(courseAmount);
  var [couponCodeText, setCouponText] = useState('');
  var [discountAmount, setDiscountAmount] = useState(0);
  var [couponCode, setCoupon] = useState('');
  var [showCoupon, setShowCoupon] = useState(false);
  var [loadCoupon, setLoadCoupon] = useState(false);
  var [loadFreeItem, setLoadFreeItem] = useState(false);
  var [loadPaidItem, setLoadPaidCourse] = useState(false);

  // console.log('printList :- ', printList);
  // console.log('eventDetails :- ', eventDetails);

  useEffect(() => {
    if (coursepricingtype === 'paid') {
      if (taxName && taxName != '' && taxRate && taxRate != '') {
        let tAmount = ((courseAmount * taxRate) / 100).toFixed(2);
        let total = parseFloat(courseAmount) + parseFloat(tAmount);

        setTaxAmount(tAmount);
        setTotalAmount(total);
      }
    }
  }, []);

  const _handleCode = e => {
    var code = e.target.value;

    setCoupon(code);
  };

  const _handleCouponSection = boolen => {
    setShowCoupon(boolen);
  };

  const _removeCouponCode = () => {
    setCouponText('');
    setDiscountAmount(0);
    setCoupon('');

    if (taxName && taxName != '' && taxRate && taxRate != '') {
      let tAmount = ((courseAmount * taxRate) / 100).toFixed(2);
      let total = parseFloat(courseAmount) + parseFloat(tAmount);

      setTaxAmount(tAmount);
      setTotalAmount(total);
    } else {
      setTotalAmount(courseAmount);
    }
  };

  const _handeCouponApply = () => {
    var ticketAr = [printList.ticketid];
    var qntAr = [1];
    var values = {
      couponcode: couponCode,
      eventid: session.eventid,
      ticketArr: ticketAr,
      quantityArr: qntAr
    };

    if (couponCode != '') {
      setLoadCoupon(true);
      props.applyCoupon(session, values, response => {
        // console.log('response----- :- ', response);
        setLoadCoupon(false);
        if (response.success === 1) {
          _handleCouponSection(false);
          setCouponText(`${couponCode}${response.data.couponAppliedText}`);
          setDiscountAmount(response.data.discountedAmount);

          if (taxName && taxName != '' && taxRate && taxRate != '') {
            let afterDis = courseAmount - response.data.discountedAmount;
            let tAmount = ((afterDis * taxRate) / 100).toFixed(2);
            let total = parseFloat(afterDis) + parseFloat(tAmount);

            setTaxAmount(tAmount);
            setTotalAmount(total);
          } else {
            setTotalAmount(courseAmount - response.data.discountedAmount);
          }
        } else if (response.success === 0) {
          showError(LocalStrings.kSomethingWrong);
        } else {
          showError(response.message);
        }
      });
    }
  };

  const _handlePayment = (token, error) => {
    // debugger;
    setLoadPaidCourse(true);
    if (!error) {
      // this.setState({loading:true});
      let qntAr = [1];
      let priceAr = [printList.tickets_by_ticketid.price];
      let ticketAr = [printList.ticketid];
      let isinvoice = 0;
      let vat = '';
      let company_name = '';
      let street = '';
      let city = '';
      let postal_code = '';
      let country = '';

      var stripeData = {
        stripeToken: token.id,
        appuserid: session.userid,
        purchasetype: 'course',
        productid: printList.courseid,
        email: session.emailid,
        name: session.firstname + ' ' + session.lastname,
        eventid: session.eventid,
        promocode: couponCode,
        amount: totalAmount,
        quantity: qntAr,
        price: priceAr,
        ticketid: ticketAr,
        currency: currency,
        isinvoice: isinvoice,
        vat: vat,
        company_name: company_name,
        street: street,
        city: city,
        postal: postal_code,
        country: country
      };

      props.makeStripePayment(session, stripeData, response => {
        // console.log('response----- :- ', response);
        setLoadPaidCourse(false);
        if (response.success === 1) {
          props.closeModal();

          props.makeEmpty_Chapters();
          props.makeEmpty_Lessions();
          props.history.push({
            pathname: '/mycoursedetails/' + printList.courseid
          });
        } else if (response.success === 0) {
          showError(LocalStrings.kSomethingWrong);
        } else {
          showError(response.message);
        }
      });
    } else {
      setLoadPaidCourse(false);
      showError(LocaleString.checkout_error_token);
    }
  };

  const _handleFreeProduct = () => {
    let qntAr = [1];
    let priceAr = [printList.tickets_by_ticketid.price];
    let ticketAr = [printList.ticketid];
    let isinvoice = 0;
    let vat = '';
    let company_name = '';
    let street = '';
    let city = '';
    let postal_code = '';
    let country = '';

    var values = {
      appuserid: session.userid,
      purchasetype: 'course',
      productid: printList.courseid,
      email: session.emailid,
      name: session.firstname + ' ' + session.lastname,
      eventid: session.eventid,
      promocode: couponCode,
      amount: totalAmount,
      quantity: qntAr,
      price: priceAr,
      ticketid: ticketAr,
      currency: currency,
      isinvoice: isinvoice,
      vat: vat,
      company_name: company_name,
      street: street,
      city: city,
      postal: postal_code,
      country: country
    };

    setLoadFreeItem(true);
    props.freeProductAccess(session, values, response => {
      // console.log('response----- :- ', response);
      setLoadFreeItem(false);
      if (response.success === 1) {
        props.closeModal();

        props.makeEmpty_Chapters();
        props.makeEmpty_Lessions();
        props.history.push({
          pathname: '/mycoursedetails/' + printList.courseid
        });
      } else if (response.success === 0) {
        showError(LocalStrings.kSomethingWrong);
      } else {
        showError(response.message);
      }
    });
  };

  var ladingButton = loadCoupon ? 'fa fa-refresh fa-spin' : 'fa fa-plus';
  var couponSaveDisabled = loadCoupon;

  var ladingFreeCourseButton = loadFreeItem ? 'fa fa-refresh fa-spin' : '';
  var freeCourseSaveDisabled = loadFreeItem;

  if (printList.coverimage) {
    coverimage =
      FILES_URL + '/' + printList.coverimage + '?api_key=' + APP_API_KEY;
  }

  return (
    <>
      <div className="course-purchase-section d-flex">
        <img className="course-coverimage" src={coverimage} />
        <div className="pl-3 p-2">
          <div className="custom-text6-medium-primary">
            {printList.coursename}
          </div>
          <div className="custom-text1-normal-secondary">
            {LocalStrings.lessons} {printList.course_lessons_by_courseid.length}
          </div>
          <div className="custom-text6-medium-theme mt-3">
            {coursepricingtype == 'free'
              ? LocalStrings.free
              : `${currency} ${courseAmount.toFixed(2)}`}
          </div>
        </div>
      </div>

      <div className="custom-text1-medium mt-3 mb-3">
        {LocalStrings.checkout_text_summary}
      </div>
      <div className="order-summary">
        <div className="row custom-text1-normal-secondary">
          <div className="col-6 text-left">{printList.coursename}</div>
          <div className="col-6 text-right">
            {coursepricingtype == 'free'
              ? LocalStrings.free
              : `${courseAmount.toFixed(2)}`}
          </div>
        </div>

        {couponCodeText != '' && discountAmount > 0 ? (
          <div className="row custom-text1-normal-secondary">
            <div className="col-6 text-left">{couponCodeText}</div>
            <div className="col-6 text-right">
              {coursepricingtype == 'free'
                ? LocalStrings.free
                : `- ${discountAmount}`}
            </div>
          </div>
        ) : (
          ''
        )}

        {coursepricingtype === 'paid' &&
        taxName &&
        taxName != '' &&
        taxRate &&
        taxRate != '' ? (
          <div className="row custom-text1-normal-secondary">
            <div className="col-6 text-left">{taxName}</div>
            <div className="col-6 text-right">+ {taxAmount}</div>
          </div>
        ) : (
          ''
        )}

        <hr />
        <div className="row custom-text1-medium">
          <div className="col-6 text-left">{LocalStrings.total}</div>
          <div className="col-6 text-right">
            {coursepricingtype == 'free'
              ? LocalStrings.free
              : `${currency} ${totalAmount.toFixed(2)}`}
          </div>
        </div>
      </div>

      {coursepricingtype === 'paid' ? (
        <div className="mt-3 mb-3">
          {showCoupon == false && couponCodeText != '' && discountAmount > 0 ? (
            <div>
              <span className="custom-text3-bold">{couponCodeText}</span>&nbsp;
              <span
                onClick={_removeCouponCode}
                className="custom-text8-medium discount-code"
              >
                ({LocalStrings.button_remove})
              </span>
            </div>
          ) : showCoupon == false &&
            couponCodeText == '' &&
            discountAmount == 0 ? (
            <span
              onClick={() => _handleCouponSection(true)}
              className="custom-text8-medium discount-code"
            >
              {LocalStrings.checkout_text_coupon_code}
            </span>
          ) : (
            ''
          )}

          {showCoupon == true ? (
            <div>
              <input
                className="coupon-code-input"
                placeholder={LocalStrings.form_label_coupon_code}
                type="text"
                value={couponCode}
                onChange={_handleCode}
              />
              <button
                onClick={_handeCouponApply}
                className="custom-icon-button-primary-md ml-1"
                type="button"
                disabled={couponSaveDisabled}
              >
                <i className={ladingButton}></i>
              </button>
              <button
                onClick={() => _handleCouponSection(false)}
                className="custom-icon-button-danger-md ml-1"
                type="button"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}

      <div>
        {coursepricingtype === 'free' || totalAmount == 0 ? (
          <button
            onClick={_handleFreeProduct}
            type="button"
            className="custom-button-primary-lg w-100 mt-2"
            disabled={freeCourseSaveDisabled}
          >
            <i className={ladingFreeCourseButton}></i>&ensp;
            {LocalStrings.button_place_order}
          </button>
        ) : (
          <Stripe
            onTokenReceived={_handlePayment}
            loadPaidItem={loadPaidItem}
          />
        )}
      </div>

      {coursepricingtype === 'paid' && totalAmount > 0 ? (
        <div className="mt-4 text-center">
          <span className="custom-text1-medium-secondary">
            {LocalStrings.checkout_text_payment_by}
          </span>{' '}
          <span className="custom-text6-medium-theme">
            {LocalStrings.stripe}
          </span>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

const mapStateToProps = state => ({
  isLoggedIn: state.isLoggedIn,
  session: state.session,
  eventDetails: state.eventDetails
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      applyCoupon,
      makeStripePayment,
      freeProductAccess,
      makeEmpty_Chapters,
      makeEmpty_Lessions
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CourseCheckout);
